import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

import StandardButton from '../app_components/StandardButton'

class ConnectRequestItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responded: false,
      accepted: false
    }

    this.renderTime = this.renderTime.bind(this)
    this.renderButtons = this.renderButtons.bind(this)
  }

  renderTime() {
    let today = moment(new Date())
    let expDate = moment(this.props.req.created_at).add(7, 'days')
    let diffTime = expDate.diff(today, 'hours')
    let days = Math.trunc(diffTime/24)
    let hours = diffTime-(days*24)
    return(`${days} DAY${days != 1 ? 'S' : ''} AND ${hours} HOUR${hours != 1 ? 'S' : ''}`)
  }

  acceptRequest() {
    this.setState({
      responded: true,
      accepted: true
    })

    const data = {
      id: this.props.req.id
    }

    $.ajax({
      url: `../acceptConnect`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  denyRequest() {
    this.setState({
      responded: true,
      accepted: false
    })

    const data = {
      id: this.props.req.id
    }

    $.ajax({
      url: `../declineConnect`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderButtons() {
    if(this.state.responded != true) {
      return(
      <div>
        <h5 style={{color: 'white', fontWeight: 200, textAlign: 'center'}}>Request expires in {this.renderTime()}</h5>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 15
        }}>
          <StandardButton text={`Decline`} size="small" primary={false} alert={true} onClick={() => this.denyRequest()} />
          <StandardButton text={`Accept`} size="small" primary={true} onClick={() => this.acceptRequest()} />
        </div>
      </div>)
    } else if (this.state.accepted === true) {
      return (
        <div>
          <h5 style={{fontWeight: 200, textAlign: 'center', marginBottom: 12, marginTop: 20}}>You are now connected to {this.props.req.requestor.preferred_name}!</h5>
          <StandardButton text={`Go to ${this.props.req.requestor.preferred_name}'s Profile`} size="large" primary={true} onClick={() => window.location.assign(`/profile/${this.props.req.requestor.slug}`)} />
        </div>
      )
    } else if(this.state.accepted === false){
      return (
        <div>
          <h5 style={{fontWeight: 200, textAlign: 'center', marginTop: 20}}>You denied connecting with {this.props.req.requestor.preferred_name}.</h5>
        </div>
      )
    }
  }

  render() {
    return(
      <div
        style={{
          width: 350,
          maxWidth: '100%',
          borderRadius: 10,
          margin: 'auto',
          marginBottom: 24,
          border: '1px solid #F2F2F2',
          padding: 15,
          paddingTop: 20,
        }}>
        <div style={{
          margin: 'auto',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column'
        }}>
          <div style={{
            margin: 'auto',
            borderRadius: 5,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row-reverse'
          }}>
            <button
              style={{textAlign: 'left', cursor: 'pointer'}}
              onClick={() => window.location.assign(`/profile/${this.props.req.requestor.slug}`)}>
              <img
                style={{height: 50, width: 50, borderRadius: 100}}
                src={this.props.req.requestor.avatar_url}></img>
            </button>
            <div>
              {this.state.responded != true && <p style={{fontSize: 8, marginBottom: 10}}>EXPIRES IN {this.renderTime()}</p>}
              <h5 style={{lineHeight: 1.5, letterSpacing: .3, fontWeight: 200}}>{this.props.req.msg}</h5>
            </div>
          </div>
          {this.renderButtons(this.props.req)}
        </div>

      </div>
    )
  }

}


const styles = {
  buttonSection: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer'
  },
  img: {
    width: 50,
    height: 50,
    marginBottom: 10
  }
}

export default ConnectRequestItem;
